import React from "react";
import BlockUi from '@availity/block-ui';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {Circles} from "react-loader-spinner";
// import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import { MDBContainer, MDBRow, MDBCol } from "mdbreact";
import { DropDownList, MultiSelect } from "@progress/kendo-react-dropdowns";
import { Grid, GridColumn, GridToolbar } from "@progress/kendo-react-grid";
import { DatePicker } from "@progress/kendo-react-dateinputs";
import { TabStrip, TabStripTab } from "@progress/kendo-react-layout";
import "./RFQ.scss";
import { Window } from "@progress/kendo-react-dialogs";
import constants from "../common/restService/constant";
import GatewayGet from "../common/restService/GatewayGet";
import { process } from "@progress/kendo-data-query";
import { count } from "@progress/kendo-data-query/dist/npm/array.operators";
import "../commonStyle/tmsStyle.scss";
import $, { event } from "jquery";
import { Link } from "react-router-dom";
import RFQGrid from "./RFQGrid";
import * as RFQService from "./RFQ.service.js";
import rfqData from "./rfq.json";
import InvoiceBidDetails from "../InvoiceBidDetails/InvoiceBidDetails";

class RFQ extends React.Component {
  constructor(props) {
    let fromDate = new Date();

    fromDate.setDate(fromDate.getDate() - 30);

    let toDate = new Date();

    super(props);
    this.state = {
      selected: 0,
      // code to comment
        // gridData: rfqData,
        gridData: [],
      initialRFQArray: [],
      rfqList: [],
      allRFQArray: [],
      invoiceDueRFQArray: [],
      openRFQArray: [],
      selectedRFQFromDate: fromDate,
      selectedRFQToDate: toDate,
      //
      isAcceptNcreateQuotationClicked: false,
      invoiceBidDetailsData: null,
    };
  }

  async getRFQData() {
    var inputObj = {};
    inputObj["Status"] = "ALL";
    //  inputObj["StartDate"] = "20210301";
    inputObj["StartDate"] = this.state.selectedRFQFromDate;
    //  inputObj["EndDate"] = "20210401";
    inputObj["EndDate"] = this.state.selectedRFQToDate;

    var formattedFreightOrderFromDate = "";
    if (
      this.state.selectedRFQFromDate != null &&
      this.state.selectedRFQFromDate != undefined &&
      this.state.selectedRFQFromDate != ""
    ) {
      var d = new Date(this.state.selectedRFQFromDate),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;
      formattedFreightOrderFromDate = [year, month, day].join("");
    }

    var formattedFreightOrderToDate = "";
    if (
      this.state.selectedRFQToDate != null &&
      this.state.selectedRFQToDate != undefined &&
      this.state.selectedRFQToDate != ""
    ) {
      var d = new Date(this.state.selectedRFQToDate),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;
      formattedFreightOrderToDate = [year, month, day].join("");
    }

    inputObj["StartDate"] = formattedFreightOrderFromDate;
    //  inputObj["EndDate"] = "20210401";
    inputObj["EndDate"] = formattedFreightOrderToDate;

    const response = await RFQService.getRFQData(inputObj);
    console.log(response);

    //  code change
    this.setState({
      gridData: response["outputData"],
      initialRFQArray: response["outputData"],
    });
    // code to comment
  //  response["outputData"] = rfqData;

    for (var i = 0; i < response["outputData"].length; i++) {
      response["outputData"][i].sourceLocation =
        response["outputData"][i].sourceLocKey +
        " " +
        response["outputData"][i].sourceAddr +
        response["outputData"][i].sourceStopContactname +
        response["outputData"][i].sourceStopTelnr +
        response["outputData"][i].sourceStopEmail;
      response["outputData"][i].destinationLocation =
        response["outputData"][i].destLocKey +
        " " +
        response["outputData"][i].destAddr +
        response["outputData"][i].destStopContactname +
        response["outputData"][i].destStopTelnr +
        response["outputData"][i].destStopEmail;

      //vm.initialRFQArray[i].sourceLocation = vm.initialRFQArray[i].sourceLocation.replace(/\//g, "</br>");
      //vm.initialRFQArray[i].destinationLocation = vm.initialRFQArray[i].destinationLocation.replace(/\//g, "</br>");

      // 19-March-19 Changes Starts
      response["outputData"][i].sourceLocation = response["outputData"][
        i
      ].sourceLocation.replace(/¿/g, "</br>");
      response["outputData"][i].destinationLocation =
        response["outputData"][i].destinationLocation.replace(
          /¿/g,
          "</br>"
        );
      // 19-March-19 Changes Ends

      var objData = {};
      objData["rfqNum"] = response["outputData"][i].rfqNum;
      this.state.rfqList.push(objData);

      // Set Freight Order Status
      response["outputData"][i].freightOrderDisplayStatus = "";
      // FO Status = 55
      if (
        response["outputData"][i].tendDocStatus == "55" ||
        response["outputData"][i].tendDocStatus == "99"
      ) {
        response["outputData"][i].freightOrderDisplayStatus =
          "Tendering Stopped";
      }
      // FO Status = 35/60/80, RFQ Status = Open and No Quotation Created
      else if (
        (response["outputData"][i].tendDocStatus == "35" ||
          response["outputData"][i].tendDocStatus == "60" ||
          response["outputData"][i].tendDocStatus == "80") &&
        response["outputData"][i].rfqStatus == "02" &&
        response["outputData"][i].tendRespAwardstatus == ""
      ) {
        response["outputData"][i].freightOrderDisplayStatus = "Open";
      }
      // FO Status = 35, RFQ Status = Open and Last Quotation Status = PE (Evaluated, Award Pending)
      else if (
        response["outputData"][i].tendDocStatus == "35" &&
        (response["outputData"][i].rfqStatus == "02" ||
          response["outputData"][i].rfqStatus == "03") &&
        response["outputData"][i].tendRespAwardstatus == "PE"
      ) {
        response["outputData"][i].freightOrderDisplayStatus =
          "Pending Intel Action";
      }
      // FO Status = 35, RFQ Status = Closed
      else if (
        response["outputData"][i].tendDocStatus == "35" &&
        response["outputData"][i].rfqStatus == "03" &&
        response["outputData"][i].tendRespAwardstatus == ""
      ) {
        response["outputData"][i].freightOrderDisplayStatus =
          "Tendering Closed";
      }
      // FO Status = 60/80, RFQ Status = Open/Closed and Last Quotation Status = PE (Evaluated, Award Pending)
      else if (
        (response["outputData"][i].tendDocStatus == "60" ||
          response["outputData"][i].tendDocStatus == "80") &&
        (response["outputData"][i].rfqStatus == "02" ||
          response["outputData"][i].rfqStatus == "03") &&
        response["outputData"][i].tendRespAwardstatus == "PE"
      ) {
        response["outputData"][i].freightOrderDisplayStatus =
          "Pending Intel Action";
      }
      // FO Status = 70, RFQ Status = Closed and Last Quotation Status = AW (Awarded)
      else if (
        response["outputData"][i].tendDocStatus == "70" &&
        response["outputData"][i].rfqStatus == "03" &&
        response["outputData"][i].tendRespAwardstatus == "AW"
      ) {
        response["outputData"][i].freightOrderDisplayStatus =
          "Awarded, Due for Invoice Submission";
      }
      // FO Status = 70, RFQ Status = Closed and Last Quotation Status = RE (Rejected)
      else if (
        response["outputData"][i].tendDocStatus == "70" &&
        response["outputData"][i].rfqStatus == "03" &&
        response["outputData"][i].tendRespAwardstatus == "RE"
      ) {
        response["outputData"][i].freightOrderDisplayStatus = "Rejected";
      }
      // FO Status = 70, RFQ Status = Closed and Last Quotation Status = "" (Empty)
      else if (
        response["outputData"][i].tendDocStatus == "70" &&
        response["outputData"][i].rfqStatus == "03" &&
        response["outputData"][i].tendRespAwardstatus == ""
      ) {
        response["outputData"][i].freightOrderDisplayStatus =
          "Tendering Closed";
      }
      // FO Status = 45 and FO Status = 60 - Set Pending Intel Action
      // && vm.initialRFQArray[i].rfqStatus == "03" && vm.initialRFQArray[i].tendRespAwardstatus == "PE"
      else if (
        response["outputData"][i].tendDocStatus == "45" ||
        response["outputData"][i].tendDocStatus == "60" ||
        response["outputData"][i].tendDocStatus == "70"
      ) {
        response["outputData"][i].freightOrderDisplayStatus =
          "Pending Intel Action";
      }
      // FO Status = 90, RFQ Status = Closed and Last Quotation Status = AW (Awarded)
      else if (
        response["outputData"][i].tendDocStatus == "90" &&
        response["outputData"][i].rfqStatus == "03" &&
        response["outputData"][i].tendRespAwardstatus == "AW"
      ) {
        response["outputData"][i].freightOrderDisplayStatus =
          "Invoice Submitted and Closed";
      }
      // FO Status = 90, RFQ Status = Closed and Last Quotation Status = RE (Rejected)
      else if (
        response["outputData"][i].tendDocStatus == "90" &&
        response["outputData"][i].rfqStatus == "03" &&
        response["outputData"][i].tendRespAwardstatus == "RE"
      ) {
        response["outputData"][i].freightOrderDisplayStatus = "Rejected";
      } else if (response["outputData"][i].tendDocStatus == "90") {
        response["outputData"][i].freightOrderDisplayStatus = "Closed";
      } else if (response["outputData"][i].tendDocStatus == "73") {
        response["outputData"][i].freightOrderDisplayStatus =
          "Sent back by authorizer, Due for invoice submission";
      } else if (response["outputData"][i].tendDocStatus == "77") {
        response["outputData"][i].freightOrderDisplayStatus =
          "Invoice submitted, Sent back by Approver.";
      }

      // Push All Records

      this.state.allRFQArray.push(response["outputData"][i]);

      // Set Data for Due For Invoice Submission Tab
      if (
        response["outputData"][i].tendDocStatus == "70" &&
        response["outputData"][i].rfqStatus == "03" &&
        response["outputData"][i].tendRespAwardstatus == "AW"
      ) {
        this.state.invoiceDueRFQArray.push(response["outputData"][i]);
      } else if (response["outputData"][i].rfqStatus == "02") {
        this.state.openRFQArray.push(response["outputData"][i]);
      }
    }
    this.setState({ blocking: false });
    // code change
    this.setState({ allRFQArray: this.state.allRFQArray });
    this.setState({ invoiceDueRFQArray: this.state.invoiceDueRFQArray });
    this.setState({ openRFQArray: this.state.openRFQArray });
  
  }

  componentDidMount() {
    this.setState({ blocking: true });
    this.getRFQData();
    // this.setState({ gridData: rfqData });
  }

  searchClick() {
    this.setState({ 
      blocking: true,
      allRFQArray: [],
      invoiceDueRFQArray: [],
      openRFQArray: [],
    });
    this.getRFQData();
  }

  fromDateHandleChange = (event) => {
    this.setState({
      selectedRFQFromDate: event.value,
    });
  };

  toDateHandleChange = (event) => {
    this.setState({
      selectedRFQToDate: event.value,
    });
  };
  handleSelect = (e) => {
    this.setState({ selected: e.selected });
  };

  onAcceptNcreateQuotationClicked(data) {
    this.setState({
      invoiceBidDetailsData: {
        ...data,
        ReqPickupDate: new Date(data.ReqPickupDate),
        ReqDeliveryDate: new Date(data.ReqDeliveryDate),
      },
    });
    this.setState({ isAcceptNcreateQuotationClicked: true });
  }

  onBidAndInvoiceSave() {
    this.setState({
      isAcceptNcreateQuotationClicked: false,
      allRFQArray: [],
      invoiceDueRFQArray: [],
      openRFQArray: [],
    });

    this.getRFQData();
  }

  render() {
    
    if (!this.state.isAcceptNcreateQuotationClicked) {
      return (
         <div className="RFQ">
          <BlockUi
            tag="div"
            className="d-block"
            blocking={this.state.blocking}
            loader={
                <Circles
                  color="#00BFFF"
                  height="100"
                  width="100"
                  timeout="6000" //3 secs
                />
            }
          >
            <div className="container-fluid">
              <div className="row">
                <div className="titleBox">
                  <label style={{ textAlign: "center", paddingTop: "10px" }}>Search</label>
                </div>
              </div>
            </div>

            <div className="titleBorder">
              <div>
                <div className="row">
                  <div className="col-md-2">
                    <label style={{ marginTop: "10px" }}>
                      RFQ Created From <em>*</em>
                    </label>
                  </div>
                  <div className="col-md-3">
                    <DatePicker
                      value={this.state.selectedRFQFromDate}
                      onChange={this.fromDateHandleChange}
                    ></DatePicker>
                  </div>
                  <div className="col-md-2">
                    <label style={{ marginTop: "10px" }}>RFQ Created To</label>
                  </div>
                  <div className="col-md-3">
                    <DatePicker
                      value={this.state.selectedRFQToDate}
                      onChange={this.toDateHandleChange}
                    ></DatePicker>
                  </div>
                </div>
              </div>

              <MDBRow>
                <MDBCol>
                  <div className="btn-group rfq" style={{display:"block"}}>
                    <button
                      className="btn k-button k-button-icontext mt"
                      onClick={this.searchClick.bind(this)}
                      style={{ borderRadius: "3px" }}
                    >
                      Search
                    </button>
                    <button
                      className="btn k-button k-button-icontext reset"
                      style={{ borderRadius: "3px" }}
                    >
                      Reset
                    </button>
                  </div>
                </MDBCol>
              </MDBRow>
            </div>

            <div className="w-98 tableSection">
                <TabStrip
                  selected={this.state.selected}
                  onSelect={this.handleSelect}
                >
                  <TabStripTab title="Open" className="tabStrib">
                    <div>
                      {/*  */}
                      <RFQGrid
                        data={this.state.openRFQArray}
                        onAcceptNcreateQuotationClicked={this.onAcceptNcreateQuotationClicked.bind(
                          this
                        )}
                      ></RFQGrid>
                    </div>
                  </TabStripTab>
                  <TabStripTab
                    title="Due For Invoice Submission"
                    className="tabStrib"
                  >
                    <div>
                      {/*  */}
                      <RFQGrid
                        data={this.state.invoiceDueRFQArray}
                        onAcceptNcreateQuotationClicked={this.onAcceptNcreateQuotationClicked.bind(
                          this
                        )}
                      ></RFQGrid>
                    </div>
                  </TabStripTab>
                  <TabStripTab title="All" className="tabStrib">
                    <div>
                      {/*  */}
                      <RFQGrid
                        data={this.state.allRFQArray}
                        onAcceptNcreateQuotationClicked={this.onAcceptNcreateQuotationClicked.bind(
                          this
                        )}
                      ></RFQGrid>
                    </div>
                  </TabStripTab>
                </TabStrip>
            </div>
          </BlockUi>
        </div>
      );
    } else {
      const {
        tor_id,
        ReqPickupDate,
        ReqDeliveryDate,
        buttonType,
        vendor_id,
        rfq_no,
        rfq_multibid_currency,
        quotationNum,
        // code added
        timeFromZone = "",
        timeToZone = ""
      } = this.state.invoiceBidDetailsData;

      const state = getButtonType();
      const invoiceInputs = getInvoiceInputs.call(this);

      function getButtonType() {
        if (buttonType === "create Quotation") {
          return 35;
        } else if (buttonType === "view Quotation") {
          return 45;
        } else if (buttonType === "create Invoice") {
          return 70;
        } else if (buttonType === "edit Invoice") {
          return 73;
        } else if (buttonType === "view Invoice") {
          return 90;
        } else if (buttonType === "copy Quotation") {
          return 35;
        }
      }

      function getInvoiceInputs() {
        if (state === 73 || state === 90) {
          return {
            childSCAC:
              this.state.invoiceBidDetailsData.invoiceInputs["childSCAC"],
            hawbNumber:
              this.state.invoiceBidDetailsData.invoiceInputs["hawbNumber"],
            proNumber:
              this.state.invoiceBidDetailsData.invoiceInputs["proNumber"],
          };
        } else {
          return {
            childSCAC: null,
            hawbNumber: null,
            proNumber: null,
          };
        }
      }

      return (
        <InvoiceBidDetails
          props={{
            currentComponent: state === 35 || state === 45 ? "bid" : "invoice",
            ParentScacCode: null,
            tor_id: tor_id,
            ReqPickupDate: ReqPickupDate,
            ReqDeliveryDate: ReqDeliveryDate,
            docStatus: state,
            vendor_id: vendor_id,
            TransportationValue: "",
            tor_Type: "ZMSB",
            onBidSaved: () => {},
            invoiceInputs: invoiceInputs,
            isEditClicked: false,
            isCreaedUserDifferentFromLoggedInUserAtStatus10: false,
            onEditingFinished: () => {},
            isNewRequest: false,
            invoiceDetailInputsOnSubmit: null,
            saveInvoiceDetailInputsOnSubmit: () => {},
            rfq_no: rfq_no,
            hideQuotation: this.onBidAndInvoiceSave.bind(this),
            quotationNum: quotationNum !== -1 && quotationNum !== undefined ? " " + quotationNum : "",
            rfq_multibid_currency: rfq_multibid_currency,
            buttonType: buttonType,
            // code added 
            timeFromZone: timeFromZone,
            timeToZone: timeToZone
          }}
        />
      );
    }
  }
}

export default RFQ;
